import React from "react"

import { Link } from "../link"
import { MultilineText } from "../multiline-text"
import s from "./get-in-touch.module.scss"
import { TOP_ID } from "./top-id"

export interface GetInTouchProps {
  slogan: string[]
}
export const GetInTouch = ({ slogan }: GetInTouchProps) => (
  <div id={s.wrapper}>
    <div className={s.canvas}>
      <div id={s.getInTouch}>
        <div>
          <svg viewBox="145.6 0 1161.6 538.8">
            <path
              opacity=".1"
              d="M131.4 105.9h116.7a324.2 324.2 0 01-1.5 32.7 115.9 115.9 0 01-6 27.3 108.951 108.951 0 01-17.1 31.35 100.027 100.027 0 01-25.35 22.8A119.152 119.152 0 01166.2 234a137.034 137.034 0 01-36.6 4.8q-26.4 0-48.15-8.7a108.661 108.661 0 01-37.35-24.45 110.735 110.735 0 01-24.3-37.8q-8.7-22.05-8.7-48.75 0-26.4 8.55-48.45A106.327 106.327 0 0143.95 33 110.429 110.429 0 0181.9 8.7Q104.1 0 131.4 0q35.4 0 62.1 15.3t42.3 47.4L180 85.8q-7.8-18.6-20.25-26.7A50.831 50.831 0 00131.4 51a56.928 56.928 0 00-24 4.95 52.012 52.012 0 00-18.45 14.1 67.679 67.679 0 00-12 22.05 89.769 89.769 0 00-4.35 28.8 91.167 91.167 0 003.75 26.7 60.305 60.305 0 0011.25 21.3 50.723 50.723 0 0018.6 13.95q11.1 4.95 25.8 4.95a71.533 71.533 0 0016.8-1.95 44.324 44.324 0 0014.55-6.3A35.847 35.847 0 00174 168.3a45 45 0 005.7-16.8h-48.3zM426 56.1h-69.9v37.8h66v49.8h-66v39H426v49.8H297.3V6.3H426zm140.1 0v176.4h-58.8V56.1H459V6.3h155.4v49.8zM825.3 6.3v226.2h-58.8V6.3zm59.4 226.2V6.3h58.8l108.6 138.3V6.3h58.5v226.2h-58.5L943.5 94.2v138.3zM107.1 356.1v176.4H48.3V356.1H0v-49.8h155.4v49.8zm135.6 63.3a60.275 60.275 0 005.1 24.9 62.277 62.277 0 0034.05 32.85 66.605 66.605 0 0048.9 0 64.129 64.129 0 0020.4-13.05 61.789 61.789 0 0013.95-19.8 63.335 63.335 0 000-49.8 61.789 61.789 0 00-13.95-19.8 64.129 64.129 0 00-20.4-13.05 66.6 66.6 0 00-48.9 0 62.277 62.277 0 00-34.05 32.85 60.275 60.275 0 00-5.1 24.9zm-61.5 0a116.557 116.557 0 0174.55-110.25Q278.7 300 306.3 300q27.3 0 50.4 9.15a119.214 119.214 0 0139.75 25.35 116.019 116.019 0 0125.95 37.95 123.161 123.161 0 010 93.9 116.018 116.018 0 01-25.95 37.95 119.216 119.216 0 01-39.75 25.35q-23.1 9.15-50.4 9.15-27.6 0-50.55-9.15A117 117 0 01181.2 419.4zm358.5-113.1v123q0 9.9.75 20.25a55.5 55.5 0 004.5 18.75 31.2 31.2 0 0011.85 13.65q8.1 5.25 22.8 5.25t22.65-5.25a32.527 32.527 0 0011.85-13.65 53.3 53.3 0 004.65-18.75q.75-10.35.75-20.25v-123H678v131.1q0 52.8-24.15 77.1t-74.25 24.3q-50.1 0-74.4-24.3t-24.3-77.1V306.3zm360.6 75.6Q879.9 357 849.9 357a61.65 61.65 0 00-24.45 4.8 58.575 58.575 0 00-32.1 32.7 64.5 64.5 0 00-4.65 24.6 65.309 65.309 0 004.65 24.9 60 60 0 0032.25 33 59.812 59.812 0 0024 4.8q28.2 0 50.7-24v69.6l-6 2.1a173.6 173.6 0 01-25.2 7.05 122.115 122.115 0 01-23.1 2.25 118.08 118.08 0 01-82.65-33.75 123.873 123.873 0 01-26.25-38.1 116.2 116.2 0 01-9.9-48.15q0-26.1 9.75-47.85A119.474 119.474 0 01846.3 300a124.074 124.074 0 0126.55 2.85 161.05 161.05 0 0127.45 8.85zm117.6 11.7h84.9v-87.3h58.8v226.2h-58.8v-93.3h-84.9v93.3h-58.8V306.3h58.8z"
            />
          </svg>
        </div>
      </div>
    </div>
    <div className={s.canvas}>
      <div id={s.slogan}>
        <p>
          <MultilineText text={slogan} />
        </p>
      </div>
    </div>
    <div id={s.margins}>
      <div id={s.height}></div>
      <Link pageID="contact" id={s.contactUs} className="button page-color">
        Contact Us
      </Link>
      <Link refId={TOP_ID} id={s.top}>
        <svg viewBox="0 0 22 12">
          <path
            d="M1,11,11,1,21,11"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />
        </svg>
      </Link>
    </div>
  </div>
)
